import { jsonParse } from 'shared/lib/jsonParse'
import { logger } from 'shared/lib'
import { eventEmitterStore } from 'entities/EventEmitter'
import { UsersApi } from 'entities/Users'

type ITermlyPayload = {
  uuid: string
  consentState: {
    [key: string]: boolean
  }
}

type ITermlyUsersData = {
  [key: string]: boolean
}

type ITermlyConsent = {
  categories: string[]
  consentState: {
    [key: string]: boolean
  }
  cookies: {
    name: string
    provider: string
    type: string
  }[]
  uuid: string | null
}

const TERMLY_KEY_DATA = 'TERMLY_SMG_data'
const TERMLY_KEY_USERS = 'TERMLY_SMG_users'

const getTermlyPayload = (): ITermlyPayload | null => {
  const payload = jsonParse<ITermlyPayload>(window.localStorage.getItem(TERMLY_KEY_DATA))

  if (!payload) return null

  return {
    uuid: payload.uuid,
    consentState: payload.consentState,
  }
}

const setTermlyPayload = (data: ITermlyPayload) => {
  window.localStorage.setItem(TERMLY_KEY_DATA, JSON.stringify(data))
}

const getTermlyUsers = (id: number) => {
  const payload = jsonParse<ITermlyUsersData>(window.localStorage.getItem(TERMLY_KEY_USERS))

  if (!payload) return false

  return Boolean(payload[id])
}

const setTermlyUsers = (id: number, value?: boolean) => {
  const payload = jsonParse<ITermlyUsersData>(window.localStorage.getItem(TERMLY_KEY_USERS))
  let users: ITermlyUsersData = {}

  if (!payload) {
    users[id] = Boolean(value)
  } else {
    users = payload

    if (!users[id]) {
      users[id] = Boolean(value)
    }

    const currentValue = Boolean(users[id])

    if (!currentValue) {
      users[id] = Boolean(value)
    }
  }

  window.localStorage.setItem(TERMLY_KEY_USERS, JSON.stringify(users))
}

const sendCookieConsent = (id: number, payload: ITermlyPayload) => {
  UsersApi.updateUsersCookieConsent(payload)
    .then(() => setTermlyUsers(id, true))
    .catch(logger.error)
}

eventEmitterStore.subscribe('termly_user_init_logged_in', (id) => {
  const payload = getTermlyPayload()

  if (!payload) return

  const isSent = getTermlyUsers(id)

  if (!isSent) {
    sendCookieConsent(id, payload)
  }
})

const TERMLY_TIMEOUT = 30_000

export const initTermly = () => {
  const observer = new MutationObserver(() => {
    if (window.Termly?.on) {
      observer.disconnect()
      window.Termly.on<ITermlyConsent>('consent', (data) => {
        if (data.uuid) {
          setTermlyPayload({
            uuid: data.uuid,
            consentState: data.consentState,
          })
          eventEmitterStore.emit('termly_user_check_logged_in')
        }
      })
    }
  })

  observer.observe(document, { childList: true, subtree: true })

  setTimeout(() => {
    observer.disconnect()
  }, TERMLY_TIMEOUT)
}
